"use client";

/**
 * "None of these fit" row, rendered as the last entry of a selection list.
 *
 * It participates in the same selection model as the cards above it — picking
 * it and pressing Continue is how the user asks for better options — so it
 * renders the same IntakeOptionCard, with its helper copy in the
 * description slot. `variant` only picks the indicator shape, matching the
 * cardinality of the list it trails.
 */

import { IntakeOptionCard } from "./IntakeOptionCard";

export type IntakeRefineRowVariant = "checkbox" | "radio";

export interface IntakeRefineRowProps {
  selected: boolean;
  onSelect: () => void;
  /** Indicator shape, per the cardinality of the list this row trails. */
  variant?: IntakeRefineRowVariant;
}

export function IntakeRefineRow({
  selected,
  onSelect,
  variant = "checkbox",
}: IntakeRefineRowProps) {
  return (
    <IntakeOptionCard
      name="None of these fit"
      description="Help me find better options."
      indicator={variant}
      selected={selected}
      onSelect={onSelect}
    />
  );
}
